import { Checkbox } from '@ordr-as/umami-react/checkbox';
import { FC } from 'react';

export interface ChildDetail {
  name: string;
  courseName: string;
}

interface Props {
  parentName: string;
  childDetails: ChildDetail[];
  isSelected: boolean;
  onToggle: (selected: boolean) => void;
}

const SelectableParentRow: FC<Props> = ({ parentName, childDetails, isSelected, onToggle }) => (
  <Checkbox className="py-3" isSelected={isSelected} onChange={onToggle}>
    <div className="flex flex-col">
      <span className="text-bold">{parentName}</span>
      {childDetails.map((child, i) => (
        <span key={i} className="text-small text-grey-dark">
          {child.name} — {child.courseName}
        </span>
      ))}
    </div>
  </Checkbox>
);

export default SelectableParentRow;
